import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { Spinner } from '~/shadcn/ui/spinner'
import { useAdminOtpLoginMutation } from './useAdminOtpLoginMutation'
import { Button } from '~/shadcn/ui/button/button'
import { FieldError } from '~/shadcn/ui/field'

function AdminOtpLoginPage() {
  const navigate = useNavigate()
  const { setAuthToken } = useAuthStore()
  const { otp } = useParams<{ otp: string }>()
  const { error, isRequestingAdminOtpLogin, adminOtpLogin } =
    useAdminOtpLoginMutation()

  useEffect(() => {
    if (!otp) {
      navigate('/login')
      return
    }

    adminOtpLogin(
      { otpParam: otp },
      {
        onSuccess: (resp) => {
          setAuthToken({
            token: resp.auth.token,
            expiration: resp.auth.expiration,
          })
          navigate('/')
        },
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-12 min-h-full">
        <div className="flex flex-col items-center justify-center gap-12 min-h-full">
          <div className="gap-12 w-full p-4 pb-12 lg:p-0 lg:pb-16">
            {isRequestingAdminOtpLogin && <Spinner className="size-10" />}
            {error != null && (
              <>
                <FieldError className="py-4">{error}</FieldError>
                <Button
                  variant="accent"
                  type="submit"
                  size="lg"
                  className="w-full"
                  onClick={() => {
                    navigate('/login')
                  }}>
                  Prihlásenie
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOtpLoginPage
